import React, { useState } from 'react';
import { useThrottleFn, useMemoizedFn } from 'ahooks';
import { Anchor } from 'antd';
import _isEmpty from 'lodash/isEmpty';
import { useStore } from '../context';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { whiteLocaleList, TimeLineProd, euLocaleList } from '@/constants/appreciationDay';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { IPageStatus } from '@/components/EcocreditsMonthlyMadness/type';

const { Link } = Anchor;
const EcoAnchor: React.FC = ({}) => {
    const { useLang, useEffect, isMobile, useRouter, getSystemTime } = useGlobal();
    const time = getSystemTime();
    const { locale } = useRouter();
    const { LUCKY_ACTIVE: luckyActivety } = useStore();
    const { isLogin, pageStatus } = useMonthlyStore();
    const { t } = useLang('ecocredits');
    const [tabPosition, setTabPosition] = useState({
        tabWidth: 0,
        offsetLeft: 0,
    });
    const [lockTab, setLockTab] = useState(false); // 当点击时不触发滚动事件
    const timeLine = TimeLineProd[locale] || TimeLineProd['us'];
    const [naActiveStatus, setNaActiveStatus] = useState<boolean>(false);
    // 活动的临时导航
    const [navArr, setNavArr] = useState<
        | {
              href: string;
              title: string;
          }[]
        | null
    >(null);

    const checkActivityNav = () => {
        if (euLocaleList.includes(locale) && pageStatus === IPageStatus.ACTIVITY) {
            const arr = [
                {
                    href: '#LUCKY_TURNTABLE1',
                    title: t('eu_activity_nav_title1'),
                },
                {
                    href: '#Refurbished',
                    title: t('eu_activity_nav_title2'),
                },
                {
                    href: '#HOT_PICK',
                    title: t('eu_activity_nav_title3'),
                },
                {
                    href: '#HOW_IT_WORKS',
                    title: t('eu_activity_nav_title4'),
                },
                {
                    href: '#ECO_BENEFITS',
                    title: t('eu_activity_nav_title5'),
                },
                {
                    href: '#WAYS_TO_EARN_POINTS',
                    title: t('eu_activity_nav_title6'),
                },
                {
                    href: '#ECOCREDIT_RULES',
                    title: t('eu_activity_nav_title7'),
                },
                {
                    href: '#ECO_FAQ',
                    title: t('eu_activity_nav_title8'),
                },
            ];
            if (isLogin) {
                arr.splice(3, 1);
            }
            setNavArr(arr);
        }

        // if (time >= jpActivityTime.start && time <= jpActivityTime.end && locale === 'jp') {
        //     const arr = [
        //         {
        //             href: '#MEMBER',
        //             title: '特典について',
        //         },
        //         {
        //             href: '#LUCKY_TURNTABLE',
        //             title: 'ラッキールーレット',
        //         },
        //         {
        //             href: '#PRODUCT',
        //             title: '会員限定商品',
        //         },
        //         {
        //             href: isLogin ? '#WAYS_TO_EARN_POINTS' : '#HOW_IT_WORKS',
        //             title: 'エコポイント制度とは？',
        //         },
        //     ];
        //     // if (_isEmpty(luckyActivety)) arr.splice(1, 1);
        //     setNavArr(arr);
        // }
    };

    const getNaActiveStatus = () => {
        if (locale === 'za') {
            if (timeLine.activity.start <= time && timeLine.activity.end >= time) {
                setNaActiveStatus(true);
            } else {
                setNaActiveStatus(false);
            }
        }
    };

    const onActiveChange = (currentActiveLink: string) => {
        if (lockTab) return;
        if (!currentActiveLink) {
            setTabPosition({
                ...tabPosition,
                tabWidth: 0,
            });
            return;
        }
        const currLink = document.querySelector<HTMLLinkElement>(`.ant-anchor-link-title-active[href="${currentActiveLink}"]`);
        if (!currLink) return;
        const { clientWidth, offsetLeft } = currLink;
        setTabPosition({
            tabWidth: clientWidth,
            offsetLeft,
        });
        if (!isMobile) return;
        scrollBar(offsetLeft);
    };

    const handleClick = (_e: any, current: any) => {
        if (!current.href) {
            setTabPosition({
                ...tabPosition,
                tabWidth: 0,
            });
            return;
        }
        const currLink = document.querySelector<HTMLLinkElement>(`.ant-anchor-link-title[href="${current.href}"]`);
        if (!currLink) return;
        const { clientWidth, offsetLeft } = currLink;
        setTabPosition({
            tabWidth: clientWidth,
            offsetLeft,
        });
        // 点击后禁止触发onChange事件
        setLockTab(true);
        setTimeout(() => {
            setLockTab(false);
        }, 1000);
        if (!isMobile) return;
        scrollBar(offsetLeft);
    };

    const { run: onActiveChangeRun } = useThrottleFn(onActiveChange, {
        wait: 100,
        leading: false,
    });

    const scrollBar = useMemoizedFn((offsetLeft: number) => {
        const wrapper = document.querySelector<HTMLDivElement>('.ant-anchor-wrapper');
        if (!wrapper) return;

        wrapper.scrollTo({
            left: offsetLeft - 20,
            behavior: 'smooth',
        });
    });

    useEffect(() => {
        const firstLink = document.querySelector<HTMLLinkElement>(`.ant-anchor-link-title[href="#WAYS_TO_EARN_POINTS"]`);
        checkActivityNav();
        if (!firstLink) return;
        const { offsetLeft } = firstLink;
        setTabPosition({
            tabWidth: 0,
            offsetLeft,
        });
        getNaActiveStatus();
    }, []);

    return (
        <div className={css.eco_anchor}>
            <Anchor targetOffset={50} showInkInFixed={false} onClick={handleClick} onChange={onActiveChangeRun}>
                {navArr ? (
                    <>
                        {navArr.map((item: any) => (
                            <Link href={item.href} title={item.title} key={item.title} />
                        ))}
                    </>
                ) : (
                    <>
                        {['kr', 'jp'].includes(locale) && !_isEmpty(luckyActivety) && <Link href="#LUCKY_TURNTABLE" title={t('lucky_turntable_title')} />}
                        {whiteLocaleList.includes(locale) && (
                            <Link
                                href="#APPRECIATION_DAY"
                                title={locale === 'za' && !naActiveStatus ? t('appreciationday_title_anchor') : t('appreciationday')}
                            />
                        )}
                        {euLocaleList.includes(locale) && !_isEmpty(luckyActivety) && <Link href="#LUCKY_TURNTABLE" title={t('lucky_turntable_title2')} />}
                        {/* {locale === 'za' && naActiveStatus && (
                            <>
                                <Link href="#MEMBER_ONLY_PRICE" title={t('double_eco_credits_products')} />
                                <Link href="#REFERRAL" title={t('referral_anchor')} />
                            </>
                        )} */}
                        {!isLogin && <Link href="#HOW_IT_WORKS" title={t('howitworks.how_it_works')} />}
                        <Link
                            href="#ECO_BENEFITS"
                            title={['fr', 'de'].includes(locale) ? t('ecoflowbenefits.ecoflowbenefits_nav') : t('ecoflowbenefits.ecoflowbenefits_title')}
                        />
                        <Link href="#WAYS_TO_EARN_POINTS" title={t('earn_points_title')} />
                        {/* {locale === 'jp' && <Link href="#Question" title={t('question_title')} />} */}
                        {['au', 'za'].includes(locale) && !_isEmpty(luckyActivety) && <Link href="#LUCKY_TURNTABLE" title={t('lucky_turntable_title')} />}
                        <Link href="#ECOCREDIT_RULES" title={t('redeem_ecocredits_title')} />
                        {!euLocaleList.concat(['kr', 'jp', 'au', 'za']).includes(locale) && !_isEmpty(luckyActivety) && (
                            <Link href="#LUCKY_TURNTABLE" title={t('lucky_turntable_title')} />
                        )}
                        <Link href="#ECO_FAQ" title={t('faq_title')} />
                        {['us', 'ca'].includes(locale) && <Link href={`/${locale}/members-store`} title={"Member's Store"} />}
                    </>
                )}

                <span
                    className="active-line"
                    style={{
                        width: `calc(${tabPosition.tabWidth}px)`,
                        left: `calc(${tabPosition.offsetLeft}px)`,
                    }}
                />
            </Anchor>
        </div>
    );
};

export default EcoAnchor;
